import { CONNECTOR_INSTANTIATE } from 'client/redux/connector/constants';
import * as actionCreators from 'client/redux/connector/actionCreators';

export const connectorInstantiate = connectorId => dispatch => {
  const types = CONNECTOR_INSTANTIATE.map(type => {
    return {type, meta: {connectorId}};
  });
  return dispatch(actionCreators.connectorInstantiate(types, connectorId));
};
